import { ApiService } from './ApiService';

class PlaceService extends ApiService {
    getAll() {
        return this.Get(`/places`);
    }
}

export default new PlaceService();
